import { render, staticRenderFns } from "./DistributionMap.vue?vue&type=template&id=32238f6c&"
import script from "./DistributionMap.vue?vue&type=script&lang=js&"
export * from "./DistributionMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports